import Swiper from 'swiper';

document.querySelectorAll<HTMLElement>('.content-slider').forEach((slider) => {
	function recalculateTotalSlides(swiperSlider: HTMLElement, swiper: typeof window.Swiper) {
		const total = swiperSlider.querySelector('.slider-pagination__total') as HTMLElement;

		if (total) {
			let totalSlides = swiper.slides.length;

			if (window.innerWidth > 769) {
				totalSlides = totalSlides - 1;
			}
			total.innerText = totalSlides.toString();
		}
	}

	new (window as Window).Swiper(slider, {
		slidesPerView: 1.125,
		spaceBetween: 20,
		navigation: {
			nextEl: '.slider-pagination__button--next',
			prevEl: '.slider-pagination__button--prev',
			disabledClass: 'slider-pagination__button--disabled',
		},

		on: {
			init(swiper: typeof window.Swiper) {
				recalculateTotalSlides(slider, swiper);
			},
			resize(swiper: typeof window.Swiper) {
				recalculateTotalSlides(slider, swiper);
			},
			slideChange(swiper: typeof window.Swiper) {
				const current = slider.querySelector('.slider-pagination__current') as HTMLElement;

				if (current) {
					current.innerText = (swiper.realIndex + 1).toString();
				}
			},
		},

		breakpoints: {
			769: {
				slidesPerView: 2,
				spaceBetween: 48,
			},
		},
	});
});
